import { createActions } from 'redux-actions';

export const { loadedAdvancedDesign, initScriptAdvancedDesign } = createActions(
  'LOADED_ADVANCED_DESIGN',
  'INIT_SCRIPT_ADVANCED_DESIGN',
);
